export function createPortalElement(portalId: string) {
    const portalElement = document.createElement('div');

    portalElement.setAttribute('id', portalId);

    const root = document.getElementById('root');

    return root && root.appendChild(portalElement);
}
